import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import React from 'react'

type Props = {
  children: React.ReactNode
  isOpen?: boolean
}

const AccordionContent = ({ children, isOpen }: Props) => {
  return (
    <Collapse in={isOpen}>
      <Box
        sx={{
          mx: 2,
          mb: 2,
          px: 2,
          py: 1,
          bgcolor: 'white',
          borderRadius: 1,
          boxShadow: '0px 0px 0px 1px rgba(18, 55, 105, 0.08), 0px 1px 2px 0px rgba(42, 59, 81, 0.12)'
        }}
      >
        {children}
      </Box>
    </Collapse>
  )
}

export default AccordionContent
